import ProjectPrivilege from "rwb/pages/project/types/enums/privilege";
import ProjectRole from "rwb/pages/project/types/enums/projectRole";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_RWB_API } = import.meta.env;

export interface ProjectRolePrivilege {
  project_id: number;
  project_title: string;
  assigned_role: ProjectRole;
  assigned_privileges: ProjectPrivilege[];
}

const useProjectsAccessList = () => {
  return useFetcher<ProjectRolePrivilege[]>(`${VITE_RWB_API}/projects/access`, {
    keepPreviousData: true,
  });
};

export default useProjectsAccessList;
